import { useDirection } from '@radix-ui/react-direction'
import * as PopoverPrimitive from '@radix-ui/react-popover'
import clsx from 'clsx'
import * as React from 'react'

import styles from './Popover.module.scss'

const Popover = PopoverPrimitive.Root
const PopoverTrigger = PopoverPrimitive.Trigger
const PopoverAnchor = PopoverPrimitive.Anchor
const PopoverArrow = PopoverPrimitive.Arrow
const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => {
  const direction = useDirection()

  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        dir={direction}
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={clsx(styles.content, className)}
        {...props}
      />
    </PopoverPrimitive.Portal>
  )
})
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { PopoverAnchor, PopoverArrow, PopoverContent, PopoverTrigger }
export default Popover
